import Navigation from "@client/lib/navigation";
import { type WithChildren } from "@client/types/WithChildren";
import * as React from "react";
import { BrowserRouter, useNavigate } from "react-router-dom";

export const NavigateSetter = () => {
  Navigation.goTo = useNavigate();

  return null;
};

const Router = (props: WithChildren) => (
  <BrowserRouter>
    <NavigateSetter />

    {props.children}
  </BrowserRouter>
);

export default Router;
